import { createTRPCProxyClient, httpBatchLink, retryLink } from "@trpc/client";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import { toast } from "sonner";
import superjson from "superjson";
import type { AppRouter } from "../../../api/src/trpc/routers/appRouter";

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();

// Create tRPC client
export const trpcClient = createTRPCProxyClient<AppRouter>({
    links: [
        // We use the retry link without actual retrying for error handling
        retryLink({
            retry: (opts) => {
                const message = opts?.error?.message;
                const code = opts?.error?.data?.code;

                if (code === "INTERNAL_SERVER_ERROR" && message) {
                    toast.error("Unexpected error", {
                        description: `${message} - Please refresh and try again or contact support at support@orsane.app.`,
                    });
                }
                if (code === "FORBIDDEN" && message) {
                    toast.error("Trial expired", {
                        description: `Your trial has expired. Please subscribe to continue.`,
                        action: {
                            label: "Upgrade",
                            onClick: () => {
                                window.location.href = "?settings=subscription";
                            },
                        },
                    });
                }

                return false; // Never retry
            },
        }),
        httpBatchLink({
            transformer: superjson,
            url: import.meta.env.VITE_TRPC_BASE_URL || "https://dummy",
            fetch(url, options) {
                return fetch(url, {
                    ...options,
                    credentials: "include",
                });
            },
        }),
    ],
});
